@if (badge) {
    <div class="reward-token-badge-container">
        <div class="promotion-used-title" *msShowInEpcot="EpcotUi">{{ promotionUsedTitle }}</div>
        <div class="reward-token-badge-container__row">
            <div class="reward-used-title" *msShowInEpcot="EntainUi">{{ rewardUsedTitle }}</div>
            <bs-reward-used-badge [badge]="badge"></bs-reward-used-badge>
        </div>
    </div>
}
